<template>
  <div class="mguu-page-footer" v-if="user_role === 'respondent' && app_design_type === 'mguu'">
    <div class="copyright">
      © MainTest {{ new Date().getFullYear() }} Все права защищены
    </div>
    <a class="email" href="mailto:mostest@ks.mos.ru">
      mostest@ks.mos.ru
    </a>
    <div class="phone">+7 (495) 957-75-75</div>
  </div>

  <div class="footer" v-else>
    <div class="footer__copyright">© MainTest {{ new Date().getFullYear() }} Все права защищены</div>

    <app-tooltip
      top
    >
      <template #activator>
        <div @click="callSupport();" class="link_user_guide">
          +7 (499) 703-39-19
        </div>
      </template>
      <span style="white-space: nowrap">Телефон технической поддержки</span>
    </app-tooltip>

    <router-link
        class="footer__link"
        :to="{
          name: 'Support'
        }"
    >
      Связаться с поддержкой
    </router-link>

    <div @click="getUserGuide();" class="link_user_guide">
      Руководство пользователя
    </div>
  </div>

</template>

<script>
import api from "@/network";
import AppTooltip from '@/components/UI/AppTooltip/AppTooltip.vue'

export default {
  components: {
    AppTooltip,
  },
  name: "AppFooter",
  props: {
    user_role: String
  },
  methods: {

    getUserGuide() {
      api.get(`user_guide`, {
        responseType: 'blob',
        params: {
          role: this.user_role
        },
      })
      .then((response) => {

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');link.href = url;
        let fileName = `Инструкция.pdf`;

        switch (this.user_role) {

          case 'admin':
            fileName = `Руководство пользователя веб-кабинета Maintest.zip`;
            break;
          case 'expert':
            fileName = `Инструкция для эксперта.pdf`;
            break;
          case 'respondent':
            fileName = `Инструкция для респондента.pdf`;
            break;
        }

        link.setAttribute('download', fileName); //or any other extension
        document.body.appendChild(link);
        link.click();
      })
      .finally(() => {})
    },
    callSupport() {
      window.location.href = "tel:+74997033919";
    }
  }
}
</script>

<style lang="scss" src="./style.scss"/>
<style lang="scss">
  .link_user_guide {
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0.2px;
    color: #00788C;
    cursor: pointer;
  }

  .mguu-page-footer {
    padding: 0 24px 0 24px;
    min-height: 60px;
    border-top: 1px solid #bfbfbf;
    display: grid;
    grid-template-columns: 1fr auto auto;
    gap: 24px;
    align-items: center;
    font-weight: 500;
    font-size: 14px;
    letter-spacing: 0.04px;

    font-family: 'Golos Text', sans-serif;
    font-optical-sizing: auto;
    font-style: normal;
    background-color: #f4f4f5;
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    * {
      font-weight: inherit;
      font-size: inherit;
    }

    .copyright {
      color: rgba(130, 130, 130, 1);
    }

    .email {
      color: rgba(142, 142, 157, 1);
      text-decoration: underline;
      text-underline-offset: 1px;
      text-decoration-thickness: 0;
    }

    .phone {
      color: rgba(142, 142, 157, 1);
    }
  }

  @media (max-width: 768px) {
    .mguu-page-footer {
      display: none;
    }
  }

</style>
